import type {BehaviorResponseBody} from '../types/Api';

/**
 * Safest-possible default: every feature disabled.
 *
 * Used as the fallback when `definition` has not loaded yet.
 * Once the backend definition arrives, the real behavior flags replace these.
 */
export const DEFAULT_BEHAVIOR: BehaviorResponseBody = {
  settingsToolPanelVisible: false,
  columnToolPanelVisible: false,
  filterToolPanelVisible: false,
  actionColumnEnabled: false,
  rangeSelectAllowed: false,
  rowSelectMode: 'NONE',
  wrapperStyle: 'CARD',
  paginationEnabled: false,
  clipboardExportAllowed: false,
  columnMenuEnabled: false,
  columnMovingAllowed: false,
  columnPinningAllowed: false,
  columnSortMode: 'NONE',
  contextMenuEnabled: false,
  columnResizingAllowed: false,
  fitToScreenAllowed: false,
  presetsEnabled: false,
  smartSearchEnabled: false,
  filterMode: 'NATIVE',
  columnHidingAllowed: false,
  columnAutoSizingAllowed: false,
  statusBarVisible: false,
  summaryRowEnabled: false,
  globalActionsEnabled: false,
};
